import React, { useState, useEffect } from 'react';
import { fetchSetting, updateSetting } from '../services/settingsService';
import { SERVICE_RECORD_ROWS_PER_PAGE_OPTIONS, PAGE_DEFAULT_LIMIT } from '../constants/pagination';

/**
 * @param {{ variant?: 'page' | 'embedded' }} [props]
 */
const ServisKaydiListeAyarPage = ({ variant = 'page' }) => {
  const embedded = variant === 'embedded';
  const [satirSayisi, setSatirSayisi] = useState(String(PAGE_DEFAULT_LIMIT));
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadSetting();
  }, []);

  const loadSetting = async () => {
    try {
      setLoading(true);
      const response = await fetchSetting('SERVIS_KAYDI_LISTE_SATIR');
      if (response?.basarili && response?.veri?.setting) {
        const d = Number(response.veri.setting.deger);
        if (SERVICE_RECORD_ROWS_PER_PAGE_OPTIONS.includes(d)) {
          setSatirSayisi(String(d));
        } else {
          setSatirSayisi(String(PAGE_DEFAULT_LIMIT));
        }
      } else {
        setSatirSayisi(String(PAGE_DEFAULT_LIMIT));
      }
    } catch {
      setSatirSayisi(String(PAGE_DEFAULT_LIMIT));
      setMessage({
        type: 'info',
        text: 'Varsayılan satır sayısı henüz kaydedilmemiş. 25 kullanılır.',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const deger = Number(satirSayisi);
    if (!SERVICE_RECORD_ROWS_PER_PAGE_OPTIONS.includes(deger)) {
      setMessage({ type: 'error', text: 'Geçerli bir satır sayısı seçin' });
      return;
    }

    try {
      setSaving(true);
      setMessage({ type: '', text: '' });
      const response = await updateSetting('SERVIS_KAYDI_LISTE_SATIR', {
        deger,
        tip: 'number',
        aciklama: 'Servis Kaydı Takip sayfasında varsayılan sayfa başına kayıt sayısı',
      });
      if (response?.basarili) {
        setMessage({ type: 'success', text: 'Kaydedildi' });
        setTimeout(() => setMessage({ type: '', text: '' }), 3000);
      } else {
        setMessage({ type: 'error', text: response?.mesaj || 'Güncelleme başarısız' });
      }
    } catch {
      setMessage({ type: 'error', text: 'Bir hata oluştu. Lütfen tekrar deneyin.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    const loader = (
      <div className="card" style={{ textAlign: 'center', padding: '40px' }}>
        <p style={{ color: '#6b7280' }}>Yükleniyor...</p>
      </div>
    );
    if (embedded) return loader;
    return (
      <div className="page-container">
        <div className="content-header">
          <h1>Servis listesi</h1>
        </div>
        {loader}
      </div>
    );
  }

  const card = (
    <div className="card" style={{ maxWidth: '700px', margin: embedded ? 0 : '0 auto' }}>
      <form onSubmit={handleSave}>
        <div style={{ marginBottom: '24px' }}>
          <label
            htmlFor="servisListeSatir"
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 500,
              color: '#374151',
              fontSize: '14px',
            }}
          >
            Servis Kaydı Takip — varsayılan satır sayısı
          </label>
          <select
            id="servisListeSatir"
            value={satirSayisi}
            onChange={(e) => setSatirSayisi(e.target.value)}
            disabled={saving}
            style={{
              width: '100%',
              maxWidth: '200px',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              fontSize: '16px',
            }}
          >
            {SERVICE_RECORD_ROWS_PER_PAGE_OPTIONS.map((n) => (
              <option key={n} value={String(n)}>
                {n}
              </option>
            ))}
          </select>
        </div>

        {message.text ? (
          <div
            style={{
              padding: '12px 16px',
              marginBottom: '20px',
              borderRadius: '6px',
              backgroundColor:
                message.type === 'success' ? '#d1fae5' : message.type === 'error' ? '#fee2e2' : '#dbeafe',
              color:
                message.type === 'success' ? '#065f46' : message.type === 'error' ? '#991b1b' : '#1e40af',
              border: `1px solid ${
                message.type === 'success' ? '#10b981' : message.type === 'error' ? '#ef4444' : '#3b82f6'
              }`,
            }}
          >
            {message.text}
          </div>
        ) : null}

        <button
          type="submit"
          disabled={saving}
          className="primary-btn"
          style={{ padding: '12px 24px' }}
        >
          {saving ? 'Kaydediliyor...' : 'Kaydet'}
        </button>
      </form>
    </div>
  );

  if (embedded) return card;

  return (
    <div className="page-container">
      <div className="content-header">
        <h1>Servis listesi ayarları</h1>
      </div>
      {card}
    </div>
  );
};

export default ServisKaydiListeAyarPage;
